<template lang="pug">
  section.hero.is-light
    .hero-head
      .container.has-text-centered
        img(
          src="../../../assets/Logo_Inventario.png",
          width="115"
        )
    .hero-body
      .container.has-text-centered
        h2.subtitle Aplicación de Inventario 🛒
</template>

<script>
export default {
  name: 'HeaderInventario.vue'
}
</script>

<style lang="css" scoped>

</style>




// WEBPACK FOOTER //
// src/components/inventario_Componentes/layout/HeaderInventario.vue